"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const inertia_react_1 = require("@inertiajs/inertia-react");
const Header = ({ pageList, currentLink, showLogoLeft }) => {
    const menuRef = React.useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: "sticky top-0 z-50 flex h-20 w-full justify-center bg-[#F2F2F2] shadow" },
            React.createElement("div", { className: "flex h-full w-full max-w-[100vw] items-center justify-between py-0 px-8 xl:px-[5%]" },
                showLogoLeft && (React.createElement("div", { className: "relative md:absolute md:left-0 md:right-0 md:ml-auto md:mr-auto h-12 w-48" },
                    React.createElement(inertia_react_1.InertiaLink, { href: "/" },
                        React.createElement("img", { src: "/pictures/logo-ansade.png", alt: "Ansade", className: "absolute left-0 h-full z-10" })))),
                React.createElement("ul", { ref: menuRef, className: `hidden list-none justify-around w-full absolute top-20 left-0 right-0 bg-white
            md:flex md:relative md:w-full md:bg-transparent md:top-0 md:left-0 md:right-0` }, pageList.map((page) => (React.createElement("li", { key: page.name, className: `hover:bg-[#006838] hover:text-white md:hover:text-black flex md:hover:bg-white
                md:relative md:hover:after:absolute md:hover:after:-bottom-0 
                md:hover:after:left-0 md:hover:after:w-full md:hover:after:border-b-2 md:hover:after:border-solid 
                md:hover:after:border-[#006838] md:hover:after:content-['']` },
                    React.createElement(inertia_react_1.InertiaLink, { href: `/${page.route}`, className: currentLink == page.route
                            ? `p-4 flex-1 md:p-2 md:px-4 flex items-center md:after:absolute md:after:-bottom-0 md:after:left-0 
                      md:after:w-full md:after:border-b-2 md:after:border-solid 
                      md:after:border-[#006838] md:after:content-[''] md:bg-white`
                            : `p-4 flex-1 md:p-2 md:px-4 flex items-center md:after:absolute md:after:-bottom-0 md:after:left-0 
                      md:after:w-full md:after:border-b-2 md:after:border-solid 
                      md:after:border-[#006838] md:after:content-['']` }, page.name))))),
                React.createElement("div", { className: "md:hidden flex items-center" },
                    React.createElement("button", { className: "outline-none mobile-menu-button", onClick: () => {
                            var _a;
                            (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.classList.toggle("hidden");
                        } },
                        React.createElement("svg", { className: "w-6 h-6 text-gray-500", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", viewBox: "0 0 24 24", stroke: "currentColor" },
                            React.createElement("path", { d: "M4 6h16M4 12h16M4 18h16" }))))))));
};
exports.default = Header;
